import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "009_sales_orders",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`sales_orders\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`order_no\` text NOT NULL,
	\`company_id\` text NOT NULL,
	\`branch_id\` text,
	\`party_type\` text DEFAULT 'customer' NOT NULL,
	\`party_id\` text NOT NULL,
	\`order_date\` text NOT NULL,
	\`expiry_date\` text,
	\`subtotal\` real DEFAULT 0 NOT NULL,
	\`tax_amount\` real DEFAULT 0 NOT NULL,
	\`total\` real DEFAULT 0 NOT NULL,
	\`status\` text DEFAULT 'draft' NOT NULL,
	\`source_quotation_id\` text,
	\`converted_to_invoice_id\` text,
	\`remarks\` text,
	\`custom_data\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`sales_orders_order_no_unique\` ON \`sales_orders\` (\`order_no\`);
CREATE INDEX IF NOT EXISTS \`so_company_status_idx\` ON \`sales_orders\` (\`company_id\`,\`status\`,\`order_date\`);
CREATE INDEX IF NOT EXISTS \`so_company_party_idx\` ON \`sales_orders\` (\`company_id\`,\`party_id\`);
CREATE INDEX IF NOT EXISTS \`so_source_quotation_idx\` ON \`sales_orders\` (\`source_quotation_id\`);
CREATE INDEX IF NOT EXISTS \`so_converted_idx\` ON \`sales_orders\` (\`converted_to_invoice_id\`);

CREATE TABLE IF NOT EXISTS \`sales_order_items\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`sales_order_id\` text NOT NULL,
	\`item_id\` text,
	\`description\` text,
	\`qty\` real DEFAULT 1 NOT NULL,
	\`rate\` real DEFAULT 0 NOT NULL,
	\`amount\` real DEFAULT 0 NOT NULL,
	\`delivered_qty\` real DEFAULT 0 NOT NULL,
	\`delivered_amount\` real DEFAULT 0 NOT NULL,
	\`billed_qty\` real DEFAULT 0 NOT NULL,
	\`billed_amount\` real DEFAULT 0 NOT NULL,
	\`account_id\` text,
	\`tax_template_id\` text,
	\`tax_amount\` real DEFAULT 0 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	FOREIGN KEY (\`sales_order_id\`) REFERENCES \`sales_orders\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`item_id\`) REFERENCES \`accounting_items\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`account_id\`) REFERENCES \`accounting_accounts\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`tax_template_id\`) REFERENCES \`accounting_tax_templates\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`soi_sales_order_idx\` ON \`sales_order_items\` (\`sales_order_id\`);

ALTER TABLE \`sales_quotations\` ADD COLUMN \`converted_to_order_id\` text;
CREATE INDEX IF NOT EXISTS \`qt_converted_order_idx\` ON \`sales_quotations\` (\`converted_to_order_id\`);
  `.trim(),
};
